
import { useState } from 'react';
import { OrderWithCustomer } from '../types/orderTypes';
import { useToast } from '@/components/ui/use-toast';
import { deleteOrder } from '@/lib/supabase/orders';

export const useOrderDeletion = (orders: OrderWithCustomer[], setOrders: React.Dispatch<React.SetStateAction<OrderWithCustomer[]>>) => {
  const { toast } = useToast();

  // Handle order deletion
  const handleDeleteOrder = async (id: string) => {
    try {
      await deleteOrder(id);
      setOrders(orders.filter(order => order.id !== id));
      toast({
        title: "Succès",
        description: "Commande supprimée avec succès",
      });
    } catch (error) {
      console.error('Erreur lors de la suppression de la commande:', error);
      toast({
        title: "Erreur",
        description: "Impossible de supprimer la commande",
        variant: "destructive",
      });
    }
  };

  // Handle bulk deletion of orders
  const handleBulkDeleteOrders = async (orderIds: string[]) => {
    if (orderIds.length === 0) return;

    try {
      // Create an array of promises for each order deletion
      const deletePromises = orderIds.map(id => deleteOrder(id));
      
      // Execute all deletion operations in parallel
      await Promise.all(deletePromises);
      
      // Update orders list by filtering out the deleted orders
      setOrders(orders.filter(order => !orderIds.includes(order.id)));
      
      toast({
        title: "Succès",
        description: `${orderIds.length} commande${orderIds.length > 1 ? 's' : ''} supprimée${orderIds.length > 1 ? 's' : ''} avec succès`,
      });
    } catch (error) {
      console.error('Erreur lors de la suppression des commandes:', error);
      toast({
        title: "Erreur",
        description: "Impossible de supprimer les commandes sélectionnées",
        variant: "destructive",
      });
    }
  };

  return {
    handleDeleteOrder,
    handleBulkDeleteOrders
  };
};
